import Vue from 'vue'
import Router from 'vue-router'




Vue.use(Router)

export default new Router({
    routes: [
        {
            path:'/',
            redirect:'/index'
        },
        {
            path:'/index',
            name:'index',
            component: () => import('../../views/index/index')
        },
        {
            path:'/ewm',
            name:'index',
            component: () => import('../../views/index/ewm')
        },
        {
            path: '/gwjc',
            name: 'gwjc',
            component: () => import('../../views/index/gwjc')
        },
        {
            path: '/xzlm',
            name: 'xzlm',
            component: () => import('../../views/index/xzlm')
        },
        {
            path: '/list1',
            name: 'list1',
            component: () => import('../../views/index/list1')
        },
        {
            path: '/list2',
            name: 'list2',
            component: () => import('../../views/index/list2')
        },
        {
            path: '/list3',
            name: 'list3',
            component: () => import('../../views/index/list3')
        },
        {
            path: '/list4',
            name: 'list4',
            component: () => import('../../views/index/list4')
        },
        {
            path: '/cjqh',
            name: 'cjqh',
            component: () => import('../../views/index/cjqh')
        },
        {
            path: '/720',
            name: '720',
            component: () => import('../../views/index/720')
        },
        {
            path: '/tyfg',
            name: 'tyfg',
            component: () => import('../../views/index/tyfg')
        },
        {
            path: '/detail',
            name: 'detail',
            component: () => import('../../views/index/detail')
        },
        {
            path: '/detail4',
            name: 'detail4',
            component: () => import('../../views/index/detail4')
        },
        {
            path: '/list_wzlj',
            name: 'list_wzlj',
            component: () => import('../../views/index/list_wzlj')
        },
        {
            path: '/list_wzlj_cx',
            name: 'list_wzlj_cx',
            component: () => import('../../views/index/list_wzlj_cx')
        },
        {
            path: '/list_wzlj_gw',
            name: 'list_wzlj_gw',
            component: () => import('../../views/index/list_wzlj_gw')
        },
        {
            path: '/list_wzlj_tc',
            name: 'list_wzlj_tc',
            component: () => import('../../views/index/list_wzlj_tc')
        },
        {
            path: '/list_wzlj_yl',
            name: 'list_wzlj_yl',
            component: () => import('../../views/index/list_wzlj_yl')
        },
        {
            path: '/list_wzlj_yw',
            name: 'list_wzlj_yw',
            component: () => import('../../views/index/list_wzlj_yw')
        },
        {
            path: '/list_wzlj_zs',
            name: 'list_wzlj_zs',
            component: () => import('../../views/index/list_wzlj_zs')
        },{
            path: '/list_wzlj_jd',
            name: 'list_wzlj_jd',
            component: () => import('../../views/index/list_wzlj_jd')
        },
        {
            path: '/lygl',
            name: 'lygl',
            component: () => import('../../views/index/lygl')
        },
        {
            path: '/xcgh',
            name: 'xcgh',
            component: () => import('../../views/index/xcgh')
        },
        {
            path: '/ms',
            name: 'ms',
            component: () => import('../../views/index/wzlj_food')
        },
        {
            path: '/zs',
            name: 'zs',
            component: () => import('../../views/index/wzlj_zs')
        },
        {
            path: '/yw',
            name: 'yw',
            component: () => import('../../views/index/wzlj_yw')
        },
        {
            path:'/gw',
            name:'gw',
            component: () => import('../../views/index/wzlj_gw')
        },
        {
            path:'/yl',
            name:'yl',
            component: () => import('../../views/index/wzlj_yl')
        },
        {
            path:'/tc',
            name:'tc',
            component: () => import('../../views/index/wzlj_tc')
        },
        {
            path:'/jd',
            name:'jd',
            component: () => import('../../views/index/wzlj_jd')
        },
        {
            path:'/cx',
            name:'cx',
            component: () => import('../../views/index/wzlj_cx')
        },
        {
            path:'/tqyb',
            name:'tqyb',
            component: () => import('../../views/index/tqyb')
        },
        {
            path:'/yjfx',
            name:'yjfx',
            component: () => import('../../views/index/yjfx')
        },
        {
            path:'/ts',
            name:'ts',
            component: () => import('../../views/index/ts')
        },
        {
            path:'/zxzx',
            name:'zxzx',
            component: () => import('../../views/index/zxzx')
        },
        {
            path:'/vr',
            name:'vr',
            component: () => import('../../views/index/vr')
        },
        {
            path: '/detail1',
            name: 'detail1',
            component: () => import('../../views/index/detail1')
        },
        {
            path: '/detail2',
            name: 'detail2',
            component: () => import('../../views/index/detail2')
        },
        {
            path: '/jqhd',
            name: 'jqhd',
            component: () => import('../../views/index/jqhd')
        },
        {
            path: '/lyxl',
            name: 'lyxl',
            component: () => import('../../views/index/lyxl')
        },
        {
            path: '/myjj',
            name: 'myjj',
            component: () => import('../../views/index/myjj')
        },
        {
            path: '/yhlj',
            name: 'yhlj',
            component: () => import('../../views/index/yhlj')
        },
        {
            path: '/lyzn',
            name: 'lyzn',
            component: () => import('../../views/index/lyzn')
        },
        {
            path: '/tsjy',
            name: 'tsjy',
            component: () => import('../../views/index/tsjy')
        },
        {
            path: '/lydh',
            name: 'lydh',
            component: () => import('../../views/index/lydh')
        },
        {
            path: '/shgn',
            name: 'shgn',
            component: () => import('../../views/index/shgn')
        },
        {
            path: '/cybd',
            name: 'cybd',
            component: () => import('../../views/index/cybd')
        },
        {
            path: '/cjwt',
            name: 'cjwt',
            component: () => import('../../views/index/cjwt')
        },
        {
            path: '/tqyb',
            name: 'tqyb',
            component: () => import('../../views/index/tqyb')
        },
    
        {
            path: '/mlxc',
            name: 'mlxc',
            component: () => import('../../views/index/mlxc')
        },
        {
            path:'/queryResult',
            name:'queryResult',
            component: () => import('../../views/index/queryResult')
        },
        {
            path:'/queryDetail',
            name:'queryDetail',
            component: () => import('../../views/index/queryDetail')
        }


    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})
